/**
 * Schema-gated setter for runtime store fields. Mirrors the `safeSet` pattern from the
 * pre-migration zustand store: parses a candidate via a schema, returns it on success,
 * else returns the current value and warns in dev. Used inside store event reducers
 * to guard primitive-shaped fields (color, fps, brushSize, projectName, onionOpacity).
 */

const IS_DEV: boolean =
  ((env: unknown): boolean => typeof env === "object" && env !== null && "DEV" in env && env.DEV === true)(
    import.meta.env,
  );

interface MinimalSchema<T> {
  safeParse: (v: unknown) => { success: true; data: T } | { success: false; error: unknown };
}

export function safeAccept<T>(
  schema: MinimalSchema<T>,
  candidate: unknown,
  current: T,
  fieldName: string,
): T {
  const r = schema.safeParse(candidate);
  if (r.success) return r.data;
  if (IS_DEV) console.warn(`[store] ${fieldName} rejected:`, candidate, r.error);
  return current;
}
